import React from 'react';
import { Box } from '@mui/material';
import { GestionDirigeantWidget, GestionDirigeantWidgetType } from '../../molecules';

export type GestionDirigeantListProps = {
    items?: Array<GestionDirigeantWidgetType>;
};

export const GestionDirigeantList: React.FunctionComponent<GestionDirigeantListProps> = function (
    props: GestionDirigeantListProps,
) {
    const { items } = props;
    return (
        <Box>
            {items
                ? items.map((itemProps: GestionDirigeantWidgetType, index) => (
                      <GestionDirigeantWidget
                          //   key={`gestionDirigeant-${itemProps.gestionDirigeant.custom_l2d.dateEffetModificationDirigeant}-${itemProps.gestionDirigeant.individu.descriptionPersonne.prenoms}}`}
                          key={`gestionDirigeant-${itemProps.gestionDirigeant.custom_l2d.dateEffetModificationDirigeant}`}
                          {...itemProps}
                          index={index}
                      />
                  ))
                : null}
        </Box>
    );
};
